import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';
import { handleSubmitEditInvestorOnFounder } from 'components/views/FounderPipeline/_helpers/founderPipeline.events';
import { $form, $view } from 'signals/global.signals';

const FounderPipelineEditModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-pipeline-edit'}
    title={`Edit ${$form.value.name}`}
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={() => handleSubmitEditInvestorOnFounder($form.value.id)}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <UniversalInput
      name="pipelineStatus"
      label="Status"
      type="select"
      options={PIPELINE_STATUS_OPTIONS}
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="previouslyCommitted"
      label="Amount Committed"
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="amountInvested"
      label="Amount Invested"
      className="mb-16"
    />
  </SimpleModal>

);

export default FounderPipelineEditModal;
